import Tooltip from './tooltip';
export type { TooltipPlacement } from './tooltip.types';

export default Tooltip;
